"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigurationLeitungFormValidator = void 0;
const echain_shared_form_validation_1 = require("@igus/echain-shared-form-validation");
const ConfigurationModel_1 = require("../ConfigurationModel");
class ConfigurationLeitungFormValidator {
    static anzahl(options) {
        return echain_shared_form_validation_1.numberValidatorCreator.createGreaterMinLessEqualMaxValidator({
            errorMessage: options.errorMessage,
            isRequired: options.isRequired != null ? options.isRequired : true,
            locale: options.languageTag,
            precision: 0,
            roundType: echain_shared_form_validation_1.RoundType.ROUND,
            thresholdMin: 0,
            thresholdMax: ConfigurationModel_1.CONFIGURATION_LEITUNG_MAX,
        });
    }
}
exports.ConfigurationLeitungFormValidator = ConfigurationLeitungFormValidator;
//# sourceMappingURL=ConfigurationLeitungFormValidator.js.map